import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdateSingleSeriesMutation = createMutationHook(
  MembershipsCreatorV2ApiClient.updateSingleSeries,
  {
    mutationKey: ['updateSingleSeries'],
  },
)
